module.exports = __webpack_public_path__ + "static/1-6a2cd3f830a6b9ddc53bbb3852cd9067.png";